import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import GlobalSearch from '../components/global-search';
import { withDefaultStyles } from '../utils/material-ui/hoc';
import MainAppBar from './main-appbar';
import MainContent from './main-content';
import MainDrawer from './main-drawer';

class Main extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <MainAppBar title='Flybits Partnerships'>
          <GlobalSearch style={{ width: '30%' }} />
        </MainAppBar>
        <MainDrawer selectedMenu='main' />
        <MainContent />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Main)));



// WEBPACK FOOTER //
// ./src/containers/main.tsx